import React from 'react';
import YoutubeMediumFormPage from 'pages/Configuration/ConfigurationViews/ConfigurationWidget/WidgetsForms/Youtube/YoutubeMedium';
import * as Yup from 'yup';
import WidgetForm from '../WidgetForm';
import useFirebase from '../../../../hooks/Firebase/useFirebase';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const YMForm = {
    video: {
        name: "video",
        placeholder: "https://www.youtube.com/...",
        label: "Video URL",
        required: true,
    },
    timer: {
        name: "timer",
        placeholder: "Timer (ms)",
        label: "Refresh timer",
        required: true
    }
}

const YMValidate = Yup.object().shape({
    [YMForm.video.name]: Yup.string().required("Required"),
    [YMForm.timer.name]: Yup.number().required("Required"),
})

const YoutubeMediumForm = (props) => {
    const [, addElement] = useFirebase();
    const [YMInitial, setYMInitial] = React.useState({
        [YMForm.video.name]: "",
        [YMForm.timer.name]: "",
    })
    const {widgets} = useSelector(state => state.widgets);

    React.useEffect(() => {
        if (props.widget) {
            setYMInitial(props.widget);
        }
    }, [props.widget])

    const handleSubmit = (values, formikBag) => {
        if (props.handleEdit) {
            props.handleEdit(values);
            const valuesParsed = widgets?.map(el => {
                if (el.id === props.widgetID) {
                    return {
                        ...el.widget,
                        ...values,
                    };
                }
                return el.widget;
            })
            addElement.setWidget("users", valuesParsed)
            toast("The widget was updated !");
            return
        }
        addElement.widget("users", {
            service_id: props.serviceSelected.id,
            widget_id: props.widgetSelected.id,
            timer: values[YMForm.timer.name],
            video: values[YMForm.video.name]
        });

        formikBag.resetForm()
        toast("The widget was added to your dashboard !");
    }

    return (
        <WidgetForm WForm={YMForm} WInitial={YMInitial} WValidate={YMValidate} handleSubmit={handleSubmit}>
            <YoutubeMediumFormPage handleEdit={props.handleEdit} />
        </WidgetForm>
    );
};

export default YoutubeMediumForm;